import React from 'react'
import styles from './style.module.css'
import ROI from '../../Product_/ROI'

const Product_3 = () => {
  return (
    <div className={styles['product3-main-container']}>
        <div className='container'>
            <div className={styles['product3-heading']}>
                Charge Smarter. Earn More.
                <div className={styles['product3-heading-span']}>
                    Best in Class Prices.
                </div>
                <div className={styles['product3-sub-heading']}>
                    BreatheEV Revenue Tool - <span className={styles['product3-BERT']}>BERT</span>
                </div>
            </div>
            <div className={styles['product3-main-BERT-container']}>
                <ROI></ROI>
            </div>
        </div>
    </div>
  )
}

export default Product_3